import SecondaryLayout from 'components/global/SecondaryLayout';
import SimpleCard from 'components/global/SimpleCard';
import { Button, Col, Image, Row } from 'react-bootstrap';
import { useNavigate } from 'react-router-dom';
import { $form } from 'signals/global.signals';
import Loadable from 'components/global/Loadable';
import UniversalInput from 'components/global/UniversalInput';
import withDismount from 'hocs/withDismount';
import { handleSignupWithPassword } from './_helpers/signup.events';

const InvestorSignup = () => {
  const navigate = useNavigate();

  return (
    <SecondaryLayout>
      <Loadable signal={$form}>
        <SimpleCard className="text-white bg-gray-800 px-40">
          <Row className="my-32 border-bottom border-gray-700 pb-16">
            <Col xs={12} className="text-center">
              <Image
                className="nav-logo mb-16"
                src="/images/logo-lg.png"
                height="100%"
              />
              <h4 className="text-center">Sign Up</h4>
              <h5 className="text-center">Create an account to get started</h5>
            </Col>
          </Row>
          <Row className="my-32 border-bottom border-gray-700 pb-32">
            <Col xs={12}>
              <UniversalInput
                name="email"
                placeholder="Email"
                label="Email"
                value={$form.value.email}
                className="mb-24"
              />
              <UniversalInput
                type="password"
                name="password"
                value={$form.value.password}
                placeholder="Password"
                label="Password"
                className="mb-24"
              />
              <UniversalInput
                type="password"
                name="confirmPassword"
                value={$form.value.confirmPassword}
                placeholder="Confirm Password"
                label="Confirm Password"
                className="mb-48"
              />
              <Button
                onClick={handleSignupWithPassword}
                disabled={!$form.value.email || !$form.value.password || !$form.value.confirmPassword}
                variant="primary"
                className="w-100 py-8"
              >
                Sign Up
              </Button>
              {/* <Row className="d-flex align-items-center px-24">
                <Col xs={5} className="border-top border-gray-200 mt-24" />
                <Col xs={2} className="text-nowrap pt-24">
                  <p className="m-0">Or</p>
                </Col>
                <Col xs={5} className="border-top border-gray-200 mt-24" />
              </Row>
              <Button
                onClick={() => handleGoogleLogin(navigate, handleCreateUser)}
                className="btn-white w-100 border border-primary mt-24 d-none"
              >
                <Image src="/images/google-login.svg" className="pb-4" />
              </Button> */}
            </Col>
          </Row>
          <Row>
            <Col className="text-center">
              <div>Already Have an Account?</div>
              <Button
                className="btn-text text-primary bg-transparent border-0 p-0 mb-4 ms-4"
                onClick={() => navigate('/login')}
              >
                Back to Login
              </Button>
            </Col>
          </Row>
        </SimpleCard>
      </Loadable>
    </SecondaryLayout>
  );
};

export default withDismount(InvestorSignup);
